// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3pepw","disabled":"FileBtn_disabled__MOPZk","warn":"FileBtn_warn__1rrPE","fade":"FileBtn_fade__SY-mg"};